exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ReplyButton{display:flex\n}\n.ReplyButton>:first-child{padding:10px;margin:-10px -8px -10px -10px\n}\n.ReplyButton .action-counter{pointer-events:none;-webkit-user-select:none;-moz-user-select:none;user-select:none\n}\n.ReplyButton .interactive:hover .svg-inline--fa,.ReplyButton .interactive.-active .svg-inline--fa{color:#0095ff;color:var(--cBlue, #0095ff)\n}", ""]);

// exports
